import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import './Login.css';
function LoginModal({ show, handleClose }) {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        
        const userData = { email, password };

        try {
            const response = await axios.post('https://agpipefitting.org.et/api/login', userData);

            if (response.status === 200) {
                const { name, token } = response.data.user;
                setMessage(`Welcome, ${name}! Login successful.`);
                localStorage.setItem('authToken', token);

                // Close the modal and navigate to the dashboard after successful login
                setTimeout(() => {
                    handleClose(); // Close the modal
                    navigate('/dashboard'); // Redirect to dashboard
                }, 2000); // Redirect delay
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.message || 'Invalid credentials, please try again.';
            setMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Login</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <Button type="submit" variant="primary" className="w-100" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </Button>
                </form>
                {message && (
                    <div
                        className={`mt-3 alert ${
                            message.includes('Invalid') ? 'alert-danger' : 'alert-success'
                        }`}
                    >
                        {message}
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default LoginModal;
